import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useContext, useState, useEffect } from "react";
import { FormContext } from '../../../context/FormContext';

function ScrollTimeForm() {
  const { formData, updateForm } = useContext(FormContext);

  const MAX_MINS = 1440;

  const [local, setLocal] = useState({
    activeMins: formData.activeMins?.toString() ?? "",
  });

  // reflect context changes if they come from elsewhere
  useEffect(() => {
    const ctxVal = Number(formData?.activeMins ?? 0);
    if (!Number.isNaN(ctxVal) && ctxVal !== local.activeMins) {
      setLocal(p => ({ ...p, activeMins: ctxVal }));
    }
  }, [formData?.activeMins]);

  // helpers
  const toNum = (v) => {
    const n = typeof v === "number" ? v : Number(v);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  };
  const fmtInt = (n) =>
    new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(n);
  const fmtCurrency = (n) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(n);

  // constants
  const DAYS = 1460;
  const REVENUE_PER_MIN = 0.34;

  // derived values
  const mins = Number(local.activeMins) || 0;
  const hoursPerDay = mins / 60;
  const totalHours = hoursPerDay * DAYS;
  const revenue = totalHours * REVENUE_PER_MIN;

  // handler
  const handleChange = (e) => {
    let raw = e.target.value;
    // strip leading zeros ("012" -> "12")
    raw = raw.replace(/^0+(?=\d)/, "");

    let num = Number(raw);
    if (num > MAX_MINS) {
      num = MAX_MINS;
      raw = String(MAX_MINS);
    }

    // allow empty string for controlled input
    setLocal(p => ({ ...p, activeMins: raw }));

    if (!Number.isNaN(num) && raw !== "") {
      updateForm?.({ activeMins: num });
    }
  };

  return (
    <>
      <div className="contents-main">
      <h1>Doomscrolling is worth dollars.</h1>

      
      <div className="" >
        <p>
        Every minute you scroll, Meta makes money.
      </p>
        <label for="activeMins"><b>How many minutes a day do you spend on Instagram?</b></label>
         <p style={{fontSize: 13, color: 'grey', marginBottom: 0, marginTop: 5}}>
        (You can find this in your Screen Time or Instagram settings)
      </p>
        <input
          id="activeMins"
          name="activeMins"
          type="number"
          min="0"
          value={local.activeMins}
          onChange={handleChange}
          style={{ marginTop: 10, outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
        />

      </div>
     
      <p>
        = {hoursPerDay.toLocaleString()} hours
      </p>
      
      <p style={{fontSize: 13, color: 'grey'}}>
        We estimate Meta makes <b>$0.34</b> for every hour you spend scrolling.
      </p>
    </div>

    <div className="contents-footer">
      <p className="footer-label">Your Doomscroll Value</p>
      <p className="footer-value">{revenue.toLocaleString('en-US', { style: 'currency', currency: 'USD'})}</p>
    </div>
  </>
    // <div className="form-container" style={{ textAlign: 'left' }}>
    //   <div className="form-header">
    //     <Tooltip key='test' anchorSelect={'#test'} html={'test'} style={{ maxWidth: 350, whiteSpace: 'normal' }} clickable />
    //     <div style={{ display: 'flex', justifyItems: 'center', paddingLeft: 15, paddingRight: 15 }}>
    //       <img src="/images/peetime.png" alt="" style={{ width: 35, height: 35, margin: 0, borderRadius: 35, paddingTop: 0 }} />
    //       <p style={{ marginTop: '7px', marginLeft: '8px', fontWeight: 'bold' }}>your_scroll_time</p>
    //     </div>
    //     <div style={{ width: '100%', height: '520px', overflow: 'hidden', position: 'relative' }}>
    //       {/* Background image */}
    //       <img
    //         src="/images/peetime.png"
    //         alt=""
    //         style={{
    //           position: 'absolute',
    //           top: 0, left: 0, width: '100%', height: '100%',
    //           opacity: 0.85,
    //           filter: 'blur(4px)',
    //           zIndex: 0
    //         }}
    //       />

    //       <div className="calculation">

    //         <div style={{ flexGrow: 2, display: "flex" }}>
    //           <div style={{ flexGrow: 3, paddingLeft: 40, paddingTop: 40, textAlign: 'left' }}>
    //             <span className="description">
    //               How many minutes per day do you spend on Instagram?
    //             </span>
    //             <div className="inputs" style={{ marginTop: 25 }}>
    //               <input
    //                 id="activeMins"
    //                 name="activeMins"
    //                 type="number"
    //                 min="0"
    //                 value={local.activeMins}
    //                 onChange={handleChange}
    //                 style={{ outline: 'none', border: '1px solid rgb(1, 152, 255)', maxWidth: 80, borderRadius: 8, height: 30, textAlign: 'center' }}
    //               />
    //               <div style={{ display: 'flex' }}>
    //                 <span style={{ marginLeft: 25, fontWeight: 900, marginTop: 5 }}>÷60</span>
    //                 <span style={{ marginLeft: 25, fontWeight: 900, marginTop: 5 }}>=</span>
    //               </div>
    //             </div>
    //           </div>

    //           <div className="secondary" style={{ flexGrow: 2, paddingRight: 40, paddingTop: 40, textAlign: 'right' }}>
    //             <div className="description" style={{ minHeight: 38 }}>
    //               Hours per day
    //             </div>
    //             <div className="result" style={{ marginTop: 29 }}>
    //               <span style={{ fontWeight: 900, height: 29, paddingTop: 3 }}>{fmtInt(hoursPerDay)}</span>
    //             </div>
    //           </div>
    //         </div>

    //         <div style={{ flexGrow: 2, display: "flex" }}>
    //           <div style={{ flexGrow: 3, paddingLeft: 40, textAlign: 'left' }}>
    //             <span className="description">
    //               Total Hours on Instagram in 90 days
    //             </span>
    //           </div>
    //           <div className="secondary" style={{ flexGrow: 2, paddingRight: 40, textAlign: 'right' }}>
    //             <div className="result">
    //               <span style={{ fontWeight: 900, height: 29 }}>x90</span>
    //             </div>
    //           </div>
    //         </div>

    //         <div style={{ flexGrow: 2, display: "flex" }}>
    //           <div style={{ flexGrow: 3, paddingLeft: 40, textAlign: 'left' }}>
    //             <span className="description">
    //               Instagram's ad revenue for every minute a user doomscrolls
    //             </span>
    //           </div>
    //           <div className="secondary" style={{ flexGrow: 2, paddingRight: 40, textAlign: 'right' }}>
    //             <div className="result" style={{ flexDirection: "column" }}>
    //               <span style={{ marginLeft: 25, fontWeight: 900 }}>x$0.30</span>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="final" style={{ flexGrow: 1, display: "flex" }}>
    //           <div style={{ flexGrow: 3, paddingLeft: 40, paddingTop: 25, textAlign: 'left' }}>
    //             <span className="description">
    //               Your Doomscroll Time Value
    //             </span>
    //           </div>
    //           <div className="secondary" style={{ flexGrow: 2, paddingRight: 40, paddingTop: 20, textAlign: 'right' }}>
    //             <div className="result">
    //               <span style={{ fontWeight: 900, marginTop: 5 }}>={fmtCurrency(revenue)}</span>
    //             </div>
    //           </div>
    //         </div>

    //       </div>
    //     </div>
    //     <div style={{ display: 'flex', justifyItems: 'center', gap: 5, marginTop: '10px', marginBottom: '10px', paddingLeft: 15, paddingRight: 15 }}>
    //       <FavoriteIcon fontSize="large"></FavoriteIcon>
    //       <span style={{ alignContent: 'center', fontWeight: 'bold', marginRight: 5 }}>188</span>
    //       <ModeCommentOutlinedIcon fontSize="large"></ModeCommentOutlinedIcon>
    //       <span style={{ alignContent: 'center', fontWeight: 'bold', marginRight: 5 }}>23</span>
    //       <SendIcon fontSize="large"></SendIcon>
    //       <span style={{ alignContent: 'center', fontWeight: 'bold', marginRight: 5 }}>4</span>
    //     </div>
    //     <div style={{ paddingLeft: 15, paddingRight: 15 }}><b>your_scroll_time</b> Even when you're not posting, your attention has value.</div>
    //     <div style={{ color: 'grey', fontSize: 14, paddingTop: 3, paddingLeft: 15, paddingRight: 15 }}>12 days ago</div>
    //   </div>
    // </div>
  );
}
export default ScrollTimeForm;
